/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeComponentGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Component Groups Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 17, 2018 - 12:11 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/17/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const COMPONENT_LIST_CONTAINER_LOADED = 'COMPONENT_LIST_CONTAINER_LOADED';
export const COMPONENT_LIST_CONTAINER_UNLOADED = 'COMPONENT_LIST_CONTAINER_UNLOADED';
export const COMPONENT_LIST_TABLE_LOADED = 'COMPONENT_LIST_TABLE_LOADED';
export const COMPONENT_LIST_TABLE_UNLOADED = 'COMPONENT_LIST_TABLE_UNLOADED';
export const COMPONENT_LIST_CHANGE_COMPONENT_GROUP = 'COMPONENT_LIST_CHANGE_COMPONENT_GROUP';
export const COMPONENT_SELECT_ROW = 'COMPONENT_SELECT_ROW';
export const COMPONENT_ADD = 'COMPONENT_ADD';
export const COMPONENT_EDIT = 'COMPONENT_EDIT';
export const COMPONENT_DELETE = 'COMPONENT_DELETE';
export const COMPONENT_DELETE_DISABLE = 'COMPONENT_DELETE_DISABLE';
export const COMPONENT_OPEN_WARNING = 'COMPONENT_OPEN_WARNING';
export const COMPONENT_CLOSE_WARNING = 'COMPONENT_CLOSE_WARNING';
export const COMPONENT_VIEW_PAGES = 'COMPONENT_VIEW_PAGES';

export const COMPONENT_EDIT_CONTAINER_LOADED = 'COMPONENT_EDIT_CONTAINER_LOADED';
export const COMPONENT_EDIT_CONTAINER_UNLOADED = 'COMPONENT_EDIT_CONTAINER_UNLOADED';
export const COMPONENT_EDIT_FORM_LOADED = 'COMPONENT_EDIT_FORM_LOADED';
export const COMPONENT_EDIT_FORM_UNLOADED = 'COMPONENT_EDIT_FORM_UNLOADED';
export const COMPONENT_SET_COMPONENT_GROUP_SELECT = 'COMPONENT_SET_COMPONENT_GROUP_SELECT';
export const COMPONENT_EDIT_DATA_LOAD = 'COMPONENT_EDIT_DATA_LOAD';
export const COMPONENT_EDIT_CONTAINER_SUBMIT = 'COMPONENT_EDIT_CONTAINER_SUBMIT';
export const COMPONENT_EDIT_CONTAINER_CANCEL = 'COMPONENT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeComponents.js